import { hydrate } from "./uiReducer";

export const saveStateToLocalstorageMiddleware =
  ({ getState }) =>
  (next) =>
  (action) => {
    next(action);
    hydrate(getState());
  };
